<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :span="22" :offset="1"  class="page-title">Stakeholder Category Maintenance</el-col>
      <el-col :span="22" :offset="1" class="hight-btn" >
        <el-button @click="showAddDialog">Add</el-button>
        <el-button @click="showModifyDialog">Modify</el-button>
        <el-button @click="handleDelete">Delete</el-button>
      </el-col>
      <el-col :span="22" :offset="1">
        <el-table class="stakeholder-category-table" empty-text="No Data" :data="categoryList.slice((currentPage-1)*pageSize,currentPage*pageSize)" ref="multipleTable" stripe
                  max-height="700" style="width: 100%" highlight-current-row @selection-change="handleSelectionChange" @row-dblclick="handleRowDBClick"
                  :default-sort = "{prop: 'categoryCode', order: 'ascending'}">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="Code" sortable prop="categoryCode">
            <template slot-scope="scope">
              <span>{{scope.row.categoryCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Name" sortable prop="categoryName">
            <template slot-scope="scope">
              <span>{{scope.row.categoryName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Description" sortable prop="categoryDescription" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span> {{scope.row.categoryDescription}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="table-nav" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10,20, 30, 40, 50]" :page-size=pageSize
                       layout="total, sizes, prev, pager, next, jumper" :total="categoryList.length">
        </el-pagination>
        <el-dialog :title="updateDialogTitle" :visible.sync="dialogVisible" width="500px" top="100px" @close='closeDialog'>
          <el-form label-position="top" :model="category" :rules="rules" ref="updateForm" class="dialog-form">
            <el-form-item label="Category Code" prop="categoryCode">
              <el-input v-model="category.categoryCode"></el-input>
            </el-form-item>
            <el-form-item label="Category Name" prop="categoryName">
              <el-input v-model="category.categoryName"></el-input>
            </el-form-item>
            <el-form-item label="Description">
              <el-input v-model="category.categoryDescription"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancelBtn">Cancel</el-button>
          <el-button type="danger" @click="saveCategory">Save</el-button>
        </span>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue'
import { findAllCategory, addNewCategory, remove } from '@/services/stakeholderCategory.service';
import Constant from '@/common/Constant'

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      category: {
        categoryCode: '',
        categoryName: '',
        categoryDescription: ''
      },
      dialogVisible: false,
      updateDialogTitle: '',
      value: '',
      categoryList: [],
      multipleSelection: [],
      currentPage: 1,
      pageSize: 10,
      rules: {
        categoryCode: [
          {required: true, message: Constant.INPUT_CATEGORY_CODE, trigger: ['blur', 'change']}
        ],
        categoryName: [
          {required: true, message: Constant.INPUT_CATEGORY_NAME, trigger: ['blur', 'change']}
        ]
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val;
    },
    handleCurrentChange (val) {
      this.currentPage = val;
    },
    handleDelete () {
      if (this.multipleSelection.length > 0) {
        this.$confirm(Constant.SELECT_DELETE, {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel'
        })
          .then(action => {
            this.deleteCategory();
          })
          .catch(_ => {});
      } else {
        this.$message.warning(Constant.NO_SELECTED);
      }
    },
    handleSelectionChange (value) {
      this.multipleSelection = value;
    },
    handleRowDBClick (row, event) {
      this.updateDialogTitle = 'Modify Category';
      this.category = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    showAddDialog () {
      this.updateDialogTitle = 'Add Category';
      this.dialogVisible = true;
    },
    async findAllCategory () {
      let categoryInfo = await findAllCategory();
      this.categoryList = categoryInfo.data;
    },
    async addNewCategory (category) {
      let categoryInfo = await addNewCategory(category);
      if (categoryInfo.code === Constant.RESPONSE_SUCCESS_CODE) {
        this.categoryList = categoryInfo.data;
        this.$message.success(Constant.SAVE_SUCCEED);
      }
      this.closeDialog();
    },
    async remove (category) {
      let categoryInfo = await remove(category);
      if (categoryInfo.code === Constant.RESPONSE_SUCCESS_CODE) {
        this.categoryList = categoryInfo.data;
        this.currentPage = 1;
      }
    },
    saveCategory () {
      this.$refs.updateForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.addNewCategory(this.category);
        }
      });
    },
    deleteCategory () {
      this.remove(this.multipleSelection);
    },
    closeDialog () {
      this.dialogVisible = false;
      this.category = {};
      this.$refs.updateForm.resetFields();
    },
    showModifyDialog () {
      if (this.multipleSelection.length === 1) {
        this.updateDialogTitle = 'Modify Category';
        this.category = JSON.parse(JSON.stringify(this.multipleSelection[0]));
        this.dialogVisible = true;
      } else {
        let selectWarningInfo = this.multipleSelection.length === 0 ? Constant.SELECT_NONE_LINE : Constant.SELECT_MULTIPLE_LINES;
        this.$message.warning(selectWarningInfo);
      }
    },
    handleCancelBtn () {
      this.$refs.updateForm.resetFields();
      this.dialogVisible = false;
    }
  },
  mounted () {
    this.findAllCategory();
  },
  watch: {
    'category.categoryCode': function (val) {
      if (val !== '' && undefined !== val) {
        this.category.categoryCode = val.toUpperCase();
      }
    }
  }
};
</script>

<style scoped>
  .hight-btn{
    padding: 30px 0 15px 0;
  }
  .text-align-left {
    text-align: left;
  }

  .page-title{
    font-size: 20px;
    margin-top: 80px;
  }
  .margin-top{
    margin-top: 30px;
  }
  .line {
    width: 1px;
    height: 700px;
    background-color: #e6e6e6;
    margin-left: 20px;
  }

  .stakeholder-category-table{
    margin-top: 15px;
  }

  .table-nav{
    position: fixed;
    bottom: 40px;
  }
  /*rewrite element-ui */
  >>>.dialog-form .el-input{
    width: 360px;
  }
  >>>.el-dialog__body{
    padding: 5px 70px;
  }
  >>>.el-dialog__footer {
    padding: 40px 70px 20px;
  }
  >>>.el-button{
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-table{
    color: black;
  }

  >>>.el-table thead{
    color: black;
  }

  >>>.el-form--label-top .el-form-item__label{
    padding: 0;
  }

  >>>.el-form-item{
    margin-bottom: 5px;
  }

  >>>.el-pager li.active{
    color: #5e89ed;
  }

  >>>.el-pager li:hover{
    color: #5e89ed;
  }

  >>>.el-checkbox__inner{
    border: 1px solid #aaaaaa;
  }

  >>>.el-form-item__label{
    line-height: 32px;
  }

  .el-input {
    margin-top: 0;
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CategoryMaintenance.vue